// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainTop_mainContainer__d96q0","typingAni":"MainTop_typingAni__v98+-","mainimage":"MainTop_mainimage__HeaKT"};